module.exports = __webpack_public_path__ + "img/tab1.19b46d77.png";